import React from "react";
import { Header, Brands, Elo, HiperCard, Master, HomeLink, Visa, Pix } from "../NewHeader.styles";
import headerImage from "../../../../images/new_header.png";
import visaBrand from "../../../../images/ccflags/visa.svg";
import mastercardBrand from "../../../../images/ccflags/mastercard.svg";
import eloBrand from "../../../../images/ccflags/elo.svg";
import hipercardBrand from "../../../../images/ccflags/hipercard.svg";
import pixBrand from "../../../../images/ccflags/logo_pix.png";

const HeaderLanding = () => {
  return (
    <>
      <Header justifyContent="space-between">
        <HomeLink to="landing">
          <img src={headerImage} alt="Claro recarga" />
        </HomeLink>
        <Brands>
          <Visa src={visaBrand} alt="Visa" />
          <Master src={mastercardBrand} alt="Mastercard" />
          <Elo src={eloBrand} alt="Elo" />
          <HiperCard src={hipercardBrand} alt="Hipercard" />
          <Pix src={pixBrand} alt="Pix" />
        </Brands>
      </Header>
    </>
  );
};

export default HeaderLanding;
